var $taxonomyFilter;

$(document).ready(function($) {
    $taxonomyFilter = $('.js-taxonomy-filter-radio');

    initTaxonomyFilter();
});

function initTaxonomyFilter() {
    $taxonomyFilter.change(function() {
        $(this).closest('form').submit();
    });

    $('.js-taxonomy-filter-button').click(function () {
        $('.js-taxonomy-filters').toggle('fast');
    });
}
